
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private pendingRequests = 0;
  private suppressed = false;
  isLoading$ = new BehaviorSubject<boolean>(false);

  suppress() {
    this.suppressed = true;
    this.pendingRequests = 0;
    this.isLoading$.next(false);
  }

  unsuppress() {
    this.suppressed = false;
  }

  show() {
    if (this.suppressed) return;
    this.pendingRequests++;
    this.isLoading$.next(true);
  }

  hide() {
    if (this.suppressed) return;
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    if (this.pendingRequests === 0) {
      this.isLoading$.next(false);
    }
  }
}

